import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function About() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section
      id="about"
      ref={ref}
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="max-w-4xl mx-auto text-center">
        <div
          className={`section-animate ${isVisible ? "visible" : ""} mb-4 md:mb-6`}
        >
          <p className="text-xs md:text-sm tracking-[0.3em] text-text-muted mb-2">
            ABOUT
          </p>
        </div>

        <h2
          className={`section-animate section-animate-delay-1 ${
            isVisible ? "visible" : ""
          } text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-snug tracking-tight text-white mb-8 md:mb-12`}
        >
          成果と採算を、同じ目線で。
        </h2>

        <div
          className={`section-animate section-animate-delay-2 ${
            isVisible ? "visible" : ""
          } space-y-4 md:space-y-6`}
        >
          <p className="text-sm md:text-base text-text-secondary leading-relaxed">
            マーケティング施策を「実施すること」ではなく、事業成果につなげることを目的に支援します。
          </p>
          <p className="text-sm md:text-base text-text-secondary leading-relaxed">
            デジタル広告の運用だけに閉じず、広告クリエイティブ、LP、計測環境までを横断して改善。
          </p>
          <p className="text-sm md:text-base text-text-secondary leading-relaxed">
            案件ごとに支援範囲・成果条件・報酬条件を明確にし、継続的な検証を通じて費用対効果の向上を目指します。
          </p>
        </div>
      </div>
    </section>
  );
}